__turbopack_context__.v({
  "Button": "ColorPicker-module-scss-module__k2cxsq__Button",
  "Button___dense": "ColorPicker-module-scss-module__k2cxsq__Button___dense",
  "ColorPicker": "ColorPicker-module-scss-module__k2cxsq__ColorPicker",
  "ColorPicker___disabled": "ColorPicker-module-scss-module__k2cxsq__ColorPicker___disabled",
  "PresetButtonColor": "ColorPicker-module-scss-module__k2cxsq__PresetButtonColor",
  "PreviewButton": "ColorPicker-module-scss-module__k2cxsq__PreviewButton",
});
